export default () => {
    document.addEventListener("DOMContentLoaded", function(event) {
        var purchasePremiumButton = document.getElementById('purchase-premium-btn');
        var form = document.getElementById('premium-form');

        if (purchasePremiumButton === null || form === null) {
          //This js is included in all pages until we move this to react, so we need to check if the elements exist.
          return;
        }


      form.addEventListener('submit', function (event) {
            event.preventDefault();
        });

        purchasePremiumButton.addEventListener('click', function () {
           var planId = getRadioVal(form, 'billing-period');
           const { loggedOut } = window.__STATE__.premiumPage;

           if (loggedOut === true) {
             console.log("logged out");
             //TODO: find a way to utilize FOSJSRouting without breaking everything.
             window.location.assign("/login?route=/new/premium/subscription%3FplanId%3D" + planId);
             return true;
           } else {
             window.location.assign("/new/premium/subscription?planId=" + planId);
             return true;
           }
        });
    });

  function getRadioVal(form, name) {
    for (var radioButton of form.elements[name]) {
      if (radioButton.hasAttribute('checked')) {
        return radioButton.value;
      }
    }
  }
}

